import { Routes, Route, Link } from 'react-router-dom';
import TeamPage from './pages/TeamPage';
import InspectorProfilePage from './pages/InspectorProfilePage';
import AccountDeletionPage from './pages/AccountDeletionPage';
import FinishMagicLinkPage from './pages/FinishMagicLinkPage';
import InstallPage from './pages/InstallPage';
import { Header, Footer } from './components/SiteChrome';

export default function App() {
  return (
    <div className="min-h-screen flex flex-col bg-sky-tint">
      <Header />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<HomePlaceholder />} />
          <Route path="/inspection-team" element={<TeamPage />} />
          <Route path="/inspectors/:slug" element={<InspectorProfilePage />} />
          <Route path="/account-deletion" element={<AccountDeletionPage />} />
          <Route path="/finishMagicLink" element={<FinishMagicLinkPage />} />
          <Route path="/install" element={<InstallPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

// Placeholder — the real /home page is still on WordPress until we port it.
function HomePlaceholder() {
  return (
    <section className="max-w-3xl mx-auto px-5 py-16">
      <h1 className="text-3xl font-semibold text-navy">Inspect Canada</h1>
      <p className="mt-3 text-slate-700">
        Home page is still served from the legacy site. The first page rebuilt
        here is <Link to="/inspection-team" className="text-accent underline">Our team</Link>.
      </p>
    </section>
  );
}

function NotFound() {
  return (
    <section className="max-w-3xl mx-auto px-5 py-16">
      <h1 className="text-2xl font-semibold text-navy">Page not found</h1>
      <p className="mt-3 text-slate-600">
        <Link to="/inspection-team" className="text-accent underline">Go to our team page</Link>.
      </p>
    </section>
  );
}
